import { render, staticRenderFns } from "./Municipios.vue?vue&type=template&id=bbe52bfe&scoped=true"
import script from "./Municipios.vue?vue&type=script&lang=js"
export * from "./Municipios.vue?vue&type=script&lang=js"
import style0 from "./Municipios.vue?vue&type=style&index=0&id=bbe52bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe52bfe",
  null
  
)

export default component.exports